import { __require as r } from "./index.es162.js";
var i = r();
export {
  i as j
};
//# sourceMappingURL=index.es44.js.map
